// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_createStyle__xTjxt {
  width: 100%;
  height: var(--SIZE_44);
  background-color: var(--COLOR_PRIMARY_600);
  color: var(--COLOR_PRIMARY_600);
}

.styles_createMiniStyle__V\\+8Ac {
  width: 100%;
  height: var(--SIZE_40);
  background-color: var(--COLOR_PRIMARY_600);
}

.styles_createMiniStyleText__NqTBL {
  font-size: var(--FONT_SIZE_SUB_TITLE);
  font-weight: var(--WEIGHT_600);
}

.styles_cancelStyle__ukKsG {
  width: 100%;
  height: var(--SIZE_44);
  background-color: var(--COLOR_FOREGROUND);
}

.styles_cancelMiniStyle__gZn5Q {
  width: 100%;
  height: var(--SIZE_40);
  background-color: var(--COLOR_FOREGROUND);
  box-shadow: 0 var(--SIZE_1) var(--SIZE_2) var(--COLOR_GRAY_900_LIGHT);
}

.styles_cancelMiniRedStyle__GE8eB {
  width: 100%;
  height: var(--SIZE_40);
  background-color: var(--COLOR_FOREGROUND);
  border: var(--SIZE_BORDER) solid var(--COLOR_FAILED);
  box-shadow: 0 var(--SIZE_1) var(--SIZE_2) var(--COLOR_GRAY_900_LIGHT);
}

.styles_cancelStyleText__xPFPB {
  color: var(--COLOR_PRIMARY_950);
}

.styles_cancelRedStyleText__B8cKP {
  color: var(--COLOR_FAILED_50);
}

.styles_cancelLargeStyleText__wFVMX {
  font-size: var(--FONT_SIZE_SUB_TITLE);
  color: var(--COLOR_PRIMARY_950);
}

.styles_closeStyle__Kdx0r {
  width: 100%;
  height: var(--SIZE_44);
  padding: 0;
  border-width: 0;
  border-color: transparent;
  box-shadow: 0 0 transparent;
  background-color: transparent;
}

.styles_closeStyleText__NqqAL {
  font-size: var(--FONT_SIZE_SUB_TITLE);
  font-weight: var(--WEIGHT_600);
  color: var(--COLOR_PRIMARY_700);
}

.styles_saveStyleText__1qH6N {
  font-size: var(--FONT_SIZE_SUB_TITLE);
  font-weight: var(--WEIGHT_600);
  color: var(--COLOR_PRIMARY_850);
}
`, "",{"version":3,"sources":["webpack://./src/components/atoms/Button/styles.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,sBAAsB;EACtB,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;EACrC,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,yCAAyC;EACzC,qEAAqE;AACvE;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,yCAAyC;EACzC,oDAAoD;EACpD,qEAAqE;AACvE;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,UAAU;EACV,eAAe;EACf,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;EACrC,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;EACrC,8BAA8B;EAC9B,+BAA+B;AACjC","sourcesContent":[".createStyle {\n  width: 100%;\n  height: var(--SIZE_44);\n  background-color: var(--COLOR_PRIMARY_600);\n  color: var(--COLOR_PRIMARY_600);\n}\n\n.createMiniStyle {\n  width: 100%;\n  height: var(--SIZE_40);\n  background-color: var(--COLOR_PRIMARY_600);\n}\n\n.createMiniStyleText {\n  font-size: var(--FONT_SIZE_SUB_TITLE);\n  font-weight: var(--WEIGHT_600);\n}\n\n.cancelStyle {\n  width: 100%;\n  height: var(--SIZE_44);\n  background-color: var(--COLOR_FOREGROUND);\n}\n\n.cancelMiniStyle {\n  width: 100%;\n  height: var(--SIZE_40);\n  background-color: var(--COLOR_FOREGROUND);\n  box-shadow: 0 var(--SIZE_1) var(--SIZE_2) var(--COLOR_GRAY_900_LIGHT);\n}\n\n.cancelMiniRedStyle {\n  width: 100%;\n  height: var(--SIZE_40);\n  background-color: var(--COLOR_FOREGROUND);\n  border: var(--SIZE_BORDER) solid var(--COLOR_FAILED);\n  box-shadow: 0 var(--SIZE_1) var(--SIZE_2) var(--COLOR_GRAY_900_LIGHT);\n}\n\n.cancelStyleText {\n  color: var(--COLOR_PRIMARY_950);\n}\n\n.cancelRedStyleText {\n  color: var(--COLOR_FAILED_50);\n}\n\n.cancelLargeStyleText {\n  font-size: var(--FONT_SIZE_SUB_TITLE);\n  color: var(--COLOR_PRIMARY_950);\n}\n\n.closeStyle {\n  width: 100%;\n  height: var(--SIZE_44);\n  padding: 0;\n  border-width: 0;\n  border-color: transparent;\n  box-shadow: 0 0 transparent;\n  background-color: transparent;\n}\n\n.closeStyleText {\n  font-size: var(--FONT_SIZE_SUB_TITLE);\n  font-weight: var(--WEIGHT_600);\n  color: var(--COLOR_PRIMARY_700);\n}\n\n.saveStyleText {\n  font-size: var(--FONT_SIZE_SUB_TITLE);\n  font-weight: var(--WEIGHT_600);\n  color: var(--COLOR_PRIMARY_850);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"createStyle": `styles_createStyle__xTjxt`,
	"createMiniStyle": `styles_createMiniStyle__V+8Ac`,
	"createMiniStyleText": `styles_createMiniStyleText__NqTBL`,
	"cancelStyle": `styles_cancelStyle__ukKsG`,
	"cancelMiniStyle": `styles_cancelMiniStyle__gZn5Q`,
	"cancelMiniRedStyle": `styles_cancelMiniRedStyle__GE8eB`,
	"cancelStyleText": `styles_cancelStyleText__xPFPB`,
	"cancelRedStyleText": `styles_cancelRedStyleText__B8cKP`,
	"cancelLargeStyleText": `styles_cancelLargeStyleText__wFVMX`,
	"closeStyle": `styles_closeStyle__Kdx0r`,
	"closeStyleText": `styles_closeStyleText__NqqAL`,
	"saveStyleText": `styles_saveStyleText__1qH6N`
};
export default ___CSS_LOADER_EXPORT___;
